import styled from "styled-components";
import footerBackground from "../../Assets/footerBackground.svg";

export const FooterContainer = styled.footer`
  display: none;
  @media (min-width: 768px) {
    width: 100%;
    height: 100px;
    background-image: url(${footerBackground});
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    background-size: cover;
  }
`;
